/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext,useState,useRef ,useEffect} from 'react';
import GlobalContext from '../../Context/GloablContext';
import { Link, useLocation} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AnimatedModel from '../../Animation/AnimatedModel';
import { AnimatePresence } from 'framer-motion';
import ConfirmationPrompt from '../../ConfirmationPrompt';
import {motion} from 'framer-motion'
import { useNavigate } from 'react-router-dom';
import { userService } from '../../../services/user.services';
import { organizationusersList } from '../../../slices/apiSlice';
import { resetOrgUserSearch } from '../../../redux/orgUserSearchSlice';
import { resetPatientSearch } from '../../../redux/ManagePatientSearchSlice';


const SideNavBar = ({role}) => {
    const location=useLocation()
    const [logOutOpen, setLogOutOpen] = useState(false);
    const [logoutLoading, setLogoutLoading] = useState(false)
    const [isAnimating,setIsAnimating]=useState(false)
    const firstName=sessionStorage.getItem('first_name');
    const lastName=sessionStorage.getItem('last_name');
    const navigate=useNavigate()
    const auth=useSelector(state=>state.auth)
    const sidebar1Objs=['Manage Organization Users','Manage Patients','Manage Monitoring Condition Templates','Manage Observers','Import','Upload File']
    const userType = sessionStorage.getItem('user_type');

    // Filter out 'Manage Organization Users' if the user is not an admin
    const modifiedSidebar1Objs = userType === 'admin'
        ? sidebar1Objs
        : sidebar1Objs.filter(item => item !== 'Manage Organization Users');
    const linksTo1=userType==="admin"?['/manage-organization-users','/manage-patients','/manage-monitoring-condition-templates','/manage-observer','/manage-import','/upload-file']:['/manage-patients','/manage-monitoring-condition-templates','/manage-observer','/manage-import','/upload-file']
    const images=userType==="admin"?['/images/manage_organization_default.svg','/images/manage_patients_default.svg','/images/manage-monitoring-template-default.svg','/images/manage_observer_default.svg','/images/importiconlight.svg','/images/uploadFile_default.svg']:['/images/manage_patients_default.svg','/images/manage-monitoring-template-default.svg','/images/manage_observer_default.svg','/images/importiconlight.svg','/images/uploadFile_default.svg']
    /* Using the useContext hook to access the state variables `isSideNavBar` and `setIsSideNavBar`
    from the `GlobalContext` context. These variables are likely used to control the visibility and
    behavior of a side navigation bar in the UI. */
    const restrict = useSelector(state=>state?.systemConfigData?.restrict)

    const {isSideBar, setIsSideBar,setToastmessage,setToastErrorMessage,setIsAdvancedSearchOpen} = useContext(GlobalContext);
   
    /**
     * This function toggles the state of a side navigation bar.
     */
    const dispatch=useDispatch()
    
    const handleLogout= async ()=>{
        setLogoutLoading(true)
        const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
        const logout = await userService.logout()
        if(logout.error === false) {
            sessionStorage.clear()
            localStorage.setItem('arcm_trust_browser_token', browserIdValue);
            dispatch(organizationusersList.util.resetApiState())
            dispatch(resetPatientSearch()) 
            setToastmessage(logout.data.message)  
            navigate('/')
            setLogoutLoading(false)  
        } else {
            setLogOutOpen(false)
            dispatch(organizationusersList.util.resetApiState())
            dispatch(resetPatientSearch()) 
            setLogoutLoading(false)
            setToastErrorMessage('Something went wrong!')
        }
    }
    
    const ref = useRef();

    const handleClickSideNavBar = () => {
        setIsSideBar(!isSideBar);
    }

    useEffect(()=>{
        restrict?setIsSideBar(true):setIsSideBar(false)
    },[restrict])

    const handleOnClickSidenav = () =>{      
        setIsAdvancedSearchOpen(false),          
        dispatch(organizationusersList.util.resetApiState());     
        dispatch(resetOrgUserSearch());     
        dispatch(resetPatientSearch())       
    }

    return (
        <AnimatePresence>
            {!isSideBar ?
                <div className='flex top-0 left-0 min-w-[256px] w-[256px] shadow-s2 h-screen rounded-tr-[12px] rounded-br-[12px] border-r border-[#0000001A] z-[99] bg-[#fff] opened_sidebar'>
                    <div className='w-full p-4'>
                        {isAnimating?<motion.div 
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            < div className='flex items-center pb-4 relative cursor-pointer'>
                                <Link to={'/profile'}  >
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.6 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.3,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01],
                                        }}>
                                        <div title="profile" className='w-11 h-11 bg-[#E7CBD2] rounded-[50%] enlarge-image transform hover:scale-120 flex justify-center items-center'>
                                            <p className='text-[#972E4C] font-semibold text-lg uppercase'>
                                                {lastName?.charAt(0) || ''}{firstName?.charAt(0) || ''}
                                            </p>
                                        </div>
                                    </motion.div>
                                </Link>
                            
                                <div className='pl-3'>
                                    <p className='text-f1 uppercase font-medium text-[#757575]'>{userType}</p>
                                    <p className='text-sm capitalize font-medium text-black'>{`${lastName} ${firstName}`}</p>
                                </div>
                                {/* onMouseEnter={()=>setIsSideBar(false)} onMouseLeave={()=>setIsSideBar(true)} */}
                                <button  className='p-1.5 border border-[#F6F6F6] rounded-lg shadow-s2 pl-1 absolute top-2 right-[-29px] bg-white' disabled={restrict} onClick={handleClickSideNavBar}>
                                    <img loading='lazy' decoding='async' src="/images/menu_slider.svg" alt="menu-icon" className='rotate-180'/>
                                </button>
                            </div>
                        </motion.div>:<>
                            <div className='flex items-center pb-4 relative'>
                                <Link to={'/profile'}>
                                    <div title="profile" className='w-11 h-11 bg-[#E7CBD2] rounded-[50%] enlarge-image transform hover:scale-120 flex justify-center items-center'>
                                        <p className='text-[#972E4C] font-semibold text-lg uppercase'>
                                            {lastName?.charAt(0) || ''}{firstName?.charAt(0) || ''}
                                        </p>
                                    </div>
                                </Link>
                                <div className='pl-3'>
                                    <p className='text-f1 uppercase font-medium text-[#757575]'>{userType}</p>
                                    <p className='text-sm capitalize font-medium text-black'>{`${lastName} ${firstName}`}</p>
                                </div>
                                {/* onMouseEnter={()=>setIsSideBar(false)} onMouseLeave={()=>setIsSideBar(true)} */}
                                <button disabled={restrict} className='p-1.5 border border-[#F6F6F6] rounded-lg shadow-s2 pl-1 absolute top-2 right-[-29px] bg-white' onClick={handleClickSideNavBar}>
                                    <img loading='lazy' decoding='async' src="/images/menu_slider.svg" alt="menu-icon" className='rotate-180'/>
                                </button>
                            </div>

                        </>}
                        <div className='h-[2px] bg-[#C5C9DA] rounded-sm mb-4'></div>
                        <ul className='h-customh7 overflow-auto scrollbar_purple'>
                            {modifiedSidebar1Objs?.map((element,index)=>(
                                isAnimating?<motion.div 
                                    animate={{ x: 0 }}
                                    initial={{ x: -10 }}
                                    transition={{duration:0.5}}
                                    key={index}
                                    className={`text-f1 font-medium mb-2`}>
                                    <li >
                                        {location.pathname!==linksTo1[index]?<Link  to={linksTo1[index]}  className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(linksTo1[index])&&!logOutOpen?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        
                                            <motion.img  
                                                initial={{ opacity: 0, scale: 0.6 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.3,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01],
                                                }}
                                            
                                                loading="lazy" decoding="async" src={images[index]} style={location.pathname.includes(linksTo1[index])&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}  alt="icon" />
                                            <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                        </Link>:<div  className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${location.pathname.includes(linksTo1[index])&&!logOutOpen?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        
                                            <motion.img  
                                                initial={{ opacity: 0, scale: 0.6 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.3,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01],
                                                }}
                                            
                                                loading="lazy" decoding="async" src={images[index]} style={location.pathname.includes(linksTo1[index])&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}  alt="icon" />
                                            <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                        </div>}
                                    </li>
                                </motion.div>: <li key={index+"1"}>
                                    {location.pathname!==linksTo1[index]?<Link onClick={()=>{handleOnClickSidenav()}} key={index+"5"} to={linksTo1[index]} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(linksTo1[index])&&!logOutOpen?'bg-[#972E4C] bg-opacity-50':""}`}> 
                                        <img
                                            loading="lazy" decoding="async" style={location.pathname.includes(linksTo1[index])&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} src={images[index]}  alt="icon"  />
                                        <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                    </Link>:<div  className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${location.pathname.includes(linksTo1[index])&&!logOutOpen?'bg-[#972E4C] bg-opacity-50':""}`}> 
                                        <img
                                            loading="lazy" decoding="async" style={location.pathname.includes(linksTo1[index])&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} src={images[index]}  alt="icon"  />
                                        <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                    </div>}
                                </li>
                            ))}
                    
                            
                        </ul>
                        <div className='h-[2px] bg-[#C5C9DA] rounded-sm mb-4'></div>
                        <ul className=''>
                            {/* {sidebar2Objs?.map((element,index)=>(
                                isAnimating?<motion.div 
                                    animate={{ x: 0 }}
                                    initial={{ x: -10 }}
                                    transition={{duration:0.5}}
                                    key={index}
                                    className={`text-f1 font-medium mb-2`} >
                                    <li >
                                        <Link to={linksTO2[index]}  className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(((linksTO2[index])&&!logOutOpen))?'bg-[#972E4C] bg-opacity-50':""}`}>
                                            <motion.img  
                                                initial={{ opacity: 0, scale: 0.6 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.3,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01],
                                                }}
                                                loading="lazy" key={index+"4"} decoding="async" src={images2[index]} style={location.pathname.includes(linksTO2[index])&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} alt="icon" />
                                            <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTO2[index])&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                        </Link>
                                    </li>
                                </motion.div>: <li key={index+"1"}>
                               
                                    <Link  to={linksTO2[index]}  className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(linksTO2[index])&&!logOutOpen?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        <img
                                            loading="lazy" decoding="async" src={images2[index]}  alt="icon" style={location.pathname.includes(linksTO2[index])&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}/>
                                        <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTO2[index])&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`} >{element}</p>
                                    </Link>
                                </li>

                            ))} */}
                            <li>
                                {isAnimating?<motion.div 
                                    animate={{ x: 0 }}
                                    initial={{ x: -10 }}
                                    transition={{duration:0.5}}
                                    className={`text-f1 font-medium mb-2`} key="logout">
                                    <button id="logout" className={`px-3 py-2.5 w-full flex items-center rounded-lg ${logOutOpen?'bg-[#972E4C] bg-opacity-50 ':''}`}  onClick={()=>{setLogOutOpen(true)}}>
                                        <motion.img  
                                            initial={{ opacity: 0, scale: 0.6 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.3,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01],
                                            }}
                                            loading="lazy" decoding="async" src={"/images/Log-out.svg"}  alt="icon"  style={logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}/>
                                        <p className={`pl-3 text-xs font-semibold ${logOutOpen?'text-[#972E4C] ':'text-[#52555D]'} `} >Logout</p>
                                    </button>
                                </motion.div>:<>
                                    <button id="logout" className={`px-3 py-2.5 w-full flex items-center rounded-lg ${logOutOpen?'bg-[#972E4C] bg-opacity-50':''}`} onClick={()=>{setLogOutOpen(true)}}>
                                        <img
                                            loading="lazy" decoding="async" src={"/images/Log-out.svg"} style={logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} alt="icon" />
                                        <p className={`pl-3 text-xs font-semibold ${logOutOpen?'text-[#972E4C] ':'text-[#52555D]'} `} >Logout</p>
                                    </button>
                                </>}
                            </li>
                 
                        </ul>
                    </div>
                </div>
                :
                <div className='flxed top-0 left-0 min-w-[30px] w-[30px] shadow-s2 h-screen rounded-tr-[12px] rounded-br-[12px] border-r border-[#0000001A] relative z-[99] bg-[#fff] closed_sidebar'>
                    {/* onMouseEnter={()=>setIsSideBar(true)} onMouseLeave={()=>setIsSideBar(false)}  */}
                    <button 
                        disabled={restrict}                    
                        onClick={handleClickSideNavBar} 
                        className='p-1.5 border border-[#F6F6F6] rounded-lg shadow-s2 pl-1 absolute top-5 right-[-12px] bg-white' 
                    >
                        <img loading='lazy' decoding='async' src="/images/menu_slider.svg" alt="menu-icon"/>
                    </button>
                </div>
            }
        
            {logOutOpen && 
            <AnimatedModel key="logout-model"
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleLogout}
                        handleClose={() => setLogOutOpen(false)}
                        tittle= {`Logout`}
                        message = {`Are you sure you want to logout?`}
                        buttonName = {`Logout`}
                        disabled={logoutLoading}
                        loadingActivation={logoutLoading}
                    />
                }
            />  
            }
        </AnimatePresence>
    );
}
const memoisedComponent=React.memo(SideNavBar)
export default memoisedComponent
